<template>
  <div class="compatibility main-container">
            <div class="compatibility_inner">
                <h1> {{ $t("compatibility.p1") }}</h1>
                <div class="summary">
                    <el-row><img v-lazy="'//doc.yctop.com/v3/images/help/compatibility/tj.png'" alt=""></el-row>
                    <el-row>{{ $t("compatibility.p2") }}<span style="color: red;">{{ $t("compatibility.p3") }}</span><img v-lazy="'//doc.yctop.com/v3/images/help/compatibility/5x.png'" alt=""></el-row>
                    <el-row>{{ $t("compatibility.p4") }}<img v-lazy="'//doc.yctop.com/v3/images/help/compatibility/4x.png'" alt=""></el-row>
                    <el-row>{{ $t("compatibility.p5") }}<img v-lazy="'//doc.yctop.com/v3/images/help/compatibility/3x.png'" alt=""></el-row>
                    <el-row><img v-lazy="'//doc.yctop.com/v3/images/help/compatibility/btj.png'" alt=""></el-row>
                    <el-row>{{ $t("compatibility.p6") }}</el-row>
                </div>
            </div>
            <div class="compatibility_inner">
                <h1>{{ $t("compatibility.p7") }}</h1>
                <div class="enhance">
                    <p>{{ $t("compatibility.p8") }}</p>
                    <h2><span>1</span>{{ $t("compatibility.p9") }}</h2>
                    <img v-lazy="'//doc.yctop.com/v3/images/help/compatibility/set.jpg'" alt="">
                    <h2><span>2</span>{{ $t("compatibility.p10") }}</h2>
                    <img v-lazy="'//doc.yctop.com/v3/images/help/compatibility/set2.jpg'" alt="">
                </div>
            </div>
        </div>
</template>
<style scoped>
.compatibility {
    margin-top: 86px;
}

.compatibility_inner {
    margin-right: 15px;
    border: 1px solid rgba(223, 227, 230, 1);
    margin-bottom: 42px;
}

.compatibility_inner h1 {
    font-size: 16px;
    font-weight: 400;
    line-height: 52px;
    padding-left: 22px;
    color: rgba(74, 144, 226, 1);
    background: rgba(248, 249, 251, 1);
    border-bottom: 1px solid rgba(223, 227, 230, 1);
}
.compatibility_inner .summary {
    padding: 16px 0 18px 22px;
}

.compatibility_inner .summary .el-row {
    font-size: 16px;
    font-weight: 400;
    color: rgba(74, 74, 74, 1);
    padding-bottom: 18px;
}

.compatibility_inner .enhance {
    padding-left: 22px;
}

.compatibility_inner .enhance img {
    margin-left: 36px;
    margin-bottom: 32px;
}

.compatibility_inner .enhance h2 {
    font-size: 16px;
    font-weight: 400;
    color: rgba(74, 144, 226, 1);
}

.compatibility_inner .enhance h2 span {
    height: 36px;
    line-height: 36px;
    display: inline-block;
    width: 36px;
    text-align: center;
    background: rgba(74, 144, 226, 1);
    font-size: 20px;
    font-weight: 400;
    color: rgba(255, 255, 255, 1);
    border-radius: 50%;
    margin-right: 12px;
    margin-bottom: 32px;
}

.compatibility_inner .enhance {
    padding-left: 22px;
}

.compatibility_inner .enhance p {
    margin-top: 19px;
    font-size: 16px;
    font-weight: 400;
    color: rgba(74, 74, 74, 1);
    padding-bottom: 41px;
    height: 22px;
    line-height: 22px;
}
</style>
<script type='babel'>
    export default {
        components: {
        	
    	}
    };
</script>